export { Modal as default } from 'react-native';
